import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import Box from '@mui/material/Box';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../constants/FieldsConst';
import { validMessage } from '../../../constants/ValidsFormConst';
import { dateformat } from '../../../helpers';
import { useNotification } from '../../../helpers/Notification';
import { LoadingWidget } from '../../../widgets';
import { FechaField } from '../../accesos/components/FechaField';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import SelectFieldDeportesComponent from '../../sistema/deportes/components/SelectFieldDeportes';
import SelectFieldTiposActividadesExtcurComponent from '../../sistema/tipos_actividades_extcur/components/SelectFieldTiposActividadesExtcur';
import { saveActividadesExtcurAction } from '../ActividadesExtcurAction';

const FormActividadesExtcur = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const actividadesExtCurStore = Redux.useSelector(
    (state) => state.actividadesExtCur,
  );
  const usuEntidadesStore = Redux.useSelector((state) => state.usuEntidades);

  const activo = actividadesExtCurStore.activo;

  const initData = {
    desde: '',
    hasta: '',
    activo: false,
    desc: '',
    idDeporte: '',
    idTipo: '',
    idEstatus: 1,
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    desde: '',
    hasta: '',
    idTipo: '',
  });
  const [loadingSave, setLoadingSave] = React.useState(false);

  React.useEffect(() => {
    if (!activo) return;
    let values = {};
    Object.keys(data).map((key) => (values[key] = activo[key]));
    setTimeout(
      () =>
        setData({
          ...values,
          idDeporte: activo.deporte ? activo.deporte.id : '',
          idTipo: activo.tipo ? activo.tipo.id : '',
        }),
      300,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (data.idTipo === 1 && !data.idDeporte) {
      notify('Seleccione un deporte', { warning: true });
      return;
    }

    if (await _validDataForm()) {
      setLoadingSave(true);
      let res = await saveActividadesExtcurAction(
        { dispatch, notify },
        activo?.id,
        {
          ...data,
          idUsuario: usuEntidadesStore.activo.usuario.id,
          idDeporte: data.idTipo !== 1 ? null : data.idDeporte,
        },
        actividadesExtCurStore.params,
      );
      if (res) setOpenModalForm(false);
      setLoadingSave(false);
    }
  };

  return (
    <Box component="form">
      <Grid container spacing={2}>
        {loadingSave && (
          <Grid item xs={12} md={12}>
            <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          </Grid>
        )}

        <Grid item xs={12} md={6}>
          <FechaField
            views={['year', 'month', 'day']}
            openTo="year"
            botonCurrentDate={false}
            label={CONST.desde.label}
            value={data.desde}
            error={dataError.desde}
            onChange={(e) =>
              _handleSetDataField(CONST.desde.name, dateformat(e, {}))
            }
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FechaField
            views={['year', 'month', 'day']}
            openTo="year"
            botonCurrentDate={false}
            label={CONST.hasta.label}
            value={data.hasta}
            error={dataError.hasta}
            onChange={(e) =>
              _handleSetDataField(CONST.hasta.name, dateformat(e, {}))
            }
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControl fullWidth size="small">
            <InputLabel id={`label_${CONST.activo.name}`}>
              Activar Fecha
            </InputLabel>
            <Select
              id={CONST.activo.name}
              value={data.activo}
              required
              labelId={`label_${CONST.activo.name}`}
              label="Activar fecha"
              onChange={(e) =>
                _handleSetDataField(CONST.activo.name, e.target.value)
              }
            >
              <MenuItem value={true}>SI</MenuItem>
              <MenuItem value={false}>NO</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={6}>
          <SelectFieldTiposActividadesExtcurComponent
            value={data.idTipo}
            required
            onChange={(idTipo) => setData({ ...data, idTipo, idDeporte: '' })}
          />
        </Grid>

        {data.idTipo === 1 && (
          <Grid item xs={12} md={12}>
            <SelectFieldDeportesComponent
              value={data.idDeporte}
              onChange={(idDeporte) =>
                _handleSetDataField(CONST.deporte.idName, idDeporte)
              }
            />
          </Grid>
        )}

        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.desc.name}
            label={CONST.desc.label}
            value={data.desc}
            multiline
            rows={3}
            onChange={(e) =>
              _handleSetDataField(CONST.desc.name, e.target.value)
            }
            helperText={dataError.desc ? validMessage.required : null}
            error={dataError.desc}
          />
        </Grid>
        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            text={activo ? 'ACTUALIZAR' : 'GUARDAR'}
            disabled={loadingSave}
            green={!activo}
            blue={activo}
            saveIcon
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormActividadesExtcur;
